// src/pages/About.js
import React from 'react'
import Back2School2 from "../app/images/schoolshoppinglist2.jpg";

const About = () => {
  return (
    <div className="container">
    <h1 className="is-size-3 has-text-weight-bold has-text-link has-text-centered">About Us</h1>
    <img src={Back2School2} className="img_responsive" alt="Back to School Shopping List" title="Back to School Shopping List" />
	  <p>Maroon bring a spring upon her cable hearties gun port transom. Cackle fruit avast trysail provost barque strike colors. Code of conduct fire in the hole crimp dead men tell no tales no prey, no pay boatswain. Lass bilge rat provost lee topgallant gangway. </p>
    <p>Hands measured fer yer chains Jolly Roger Gold Road hornswaggle yard. Square-rigged quarterdeck Plate Fleet broadside yardarm bilge. Gangplank lanyard square-rigged parley measured fer yer chains lad. Piracy spanker careen heave to trysail dead men tell no tales. </p>
    <p>Heave to capstan Plate Fleet aft fathom scallywag gibbet. To go on account boom topsail league brig bilge schooner.  Cat o'nine tails snow matey six pounders come about wherry. Davy Jones' Locker bring a spring upon her cable jack matey Yellow Jack measured fer yer chains. Scurvy Shiver me timbers long boat chase guns ahoy keel. Ahoy warp draft scourge of the seven seas rum yawl.</p>
      <br />
	</div>
  )
}

export default About
